import React, { useEffect, useState } from 'react';
import SearchHeader from "../../Reuseablecomponent/SearchHeader";
import {useDispatch,useSelector} from 'react-redux'
import { appSettingsAction, appSettingsTableDataStart } from '../../../redux/actions/MasterActions';
import RoleSetting from '../../roleSetting/RoleSetting';
import RoleList from './RoleList';
import { useQuery } from 'react-query';
import { privateRequest } from '../../../api/apiConfig/privateRequest';
import { showErrorNotification } from '../../../customHooks';
import Paginations from './Paginations';
import RoleModal from '../Modals/RoleModal';

const Setting = () => {
 const [datas, setDatas] = useState([])
 const [skillname, setSkillname] = useState([])
  const {isDataFetch} = useSelector(state=>state.master['appSetting'])
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState("");
  const [reload, setReload] = useState(false);
  
  const getSearchValue = (value) => {
    setSearchValue(value);
  };
  
    
  useEffect(() => {
   
    // dispatch(appSettingsAction())
  }, []);
  return( 
  <div>
     
      <RoleList/>
      <div className="pagination_settings">
      <Paginations  />
      </div>
      
    </div>
  )
};

export default Setting;
